export enum ReportTypes {
  Lesson = "lessonReport",
  Level = "levelReport",
  Unit = "unitReport",
  LevelIndividual = "levelReportIndividual",
  UnitIndividual = "unitReportIndividual",
  AssessmentReport = "assessment",
  DiagnosticTestReport = "diagnosticTestReport",
  BaselineTestReport = "baseline",
  ProgressReport = "progressReport"
}
